import Highcharts from "highcharts";
import PatternFill from "highcharts/modules/pattern-fill";
import {
    dark,
    light
} from "../../../presentation/services/HighchartsTheme/HighcharttsTheme";
require("highcharts/highcharts-more")(Highcharts);
PatternFill(Highcharts);

class DashboardRenderService {
    constructor($rootScope, ThemesService) {
        this.$rootScope = $rootScope;
        this.ThemesService = ThemesService;

        this.chartsToBeRendered = new Map();
        this.chartsToBeUpdated = new Map();
        this.renderingCursor = null;

        this.concurrencyLimit = 30;
        this.debufferingChartTime = 100;
        this.debufferingChartBatchTime = 500;
        this.timeout = null;
        this.runningTimeouts = [];
        this.maxInactiveTimeBeforeStartRendering = 500;

        this._setTheme();
        this._setLanguage();

        this.$rootScope.$on("THEMES_SERVICE_THEME_CHANGED", () => {
            this.stopAllRendering();
            this._setTheme();
        });
    }

    _setTheme() {
        const currentTheme = this.ThemesService.getTheme();
        Highcharts.setOptions(currentTheme === "dark" ? dark : light);
    }

    _setLanguage() {
        Highcharts.setOptions({
            lang: {
                months: [
                    "Janeiro",
                    "Fevereiro",
                    "Março",
                    "Abril",
                    "Maio",
                    "Junho",
                    "Julho",
                    "Agosto",
                    "Setembro",
                    "Outubro",
                    "Novembro",
                    "Dezembro"
                ],
                shortMonths: [
                    "Jan",
                    "Fev",
                    "Mar",
                    "Abr",
                    "Mai",
                    "Jun",
                    "Jul",
                    "Ago",
                    "Set",
                    "Out",
                    "Nov",
                    "Dez"
                ]
            }
        });
    }

    registerVisualizationStructuresToBeRender(chartId, structure, isUpdate) {
        const targetMap = isUpdate
            ? this.chartsToBeUpdated
            : this.chartsToBeRendered;
        targetMap.set(chartId, { chartId, structure });

        clearTimeout(this.timeout);
        this.timeout = setTimeout(
            () =>
                this._startChartsRendering(
                    this._getChartsForRendering(targetMap),
                    targetMap
                ),
            this.maxInactiveTimeBeforeStartRendering
        );
    }

    stopAllRendering() {
        this._clearRunningTimeouts();
        this.chartsToBeRendered.clear();
        this.chartsToBeUpdated.clear();
        clearTimeout(this.timeout);
        this.timeout = null;
    }

    _getChartsForRendering(map) {
        const charts = Array.from(map.values()).splice(
            0,
            this.concurrencyLimit
        );
        charts.forEach((chart) => map.delete(chart.chartId));
        return charts;
    }

    _startChartsRendering(chartsToBeRender, map) {
        for (const chartToBeRender of chartsToBeRender) {
            const runningTimeout = setTimeout(
                () => this._renderChart(chartToBeRender),
                this.debufferingChartTime
            );

            this.runningTimeouts.push(runningTimeout);
        }

        if (map.size > 0) {
            const runningTimeout = setTimeout(
                () =>
                    this._startChartsRendering(
                        this._getChartsForRendering(map),
                        map
                    ),
                this.debufferingChartBatchTime
            );
            this.runningTimeouts.push(runningTimeout);
        }
    }

    _clearRunningTimeouts() {
        this.runningTimeouts.forEach(clearTimeout);
        this.runningTimeouts = [];
    }

    _renderChart(chartToBeRender) {
        const { chartId, structure } = chartToBeRender;
        const chart = new Highcharts.Chart(structure);
        this.$rootScope.$emit("CHART_CREATED", chartId, chart);
    }
}

DashboardRenderService.$inject = ["$rootScope", "ThemesService"];

angular
    .module("nucont.shared")
    .service("DashboardRenderService", DashboardRenderService);
